<template>
  <main>
    <section class="fk-contents">
      <div class="mod-notes-box">
        <dl>
          <dt>{{$t('Order.Attention.NotComplete')}}</dt>
        </dl>
      </div>

      <div class="mod-has-label">
        <span class="label">{{$t('Cart.ReceiveStore')}}</span>
          <div class="mod-normal-box">
          <p class="store-name">
            <img :src="importImageUri(getSelectStore.image_url)" alt="First Kitchen">
            <span class="name">{{getSelectStore.store_name}}</span>
          </p>
          <p class="store-address">{{getSelectStore.address}}</p>
          <p class="store-address" style="font-weight:bold; margin-bottom:5px;">{{$t('StoreInfo.ReceptionTime')}}</p>
          <dl class="store-business-hours" style="margin-top:0;" v-if="getSelectStore.has_morning_menu">
            <dt>{{$t('StoreInfo.Morning')}}</dt>
            <dd>{{getSelectStore.outputs.morningTime}}</dd>
          </dl>
          <dl class="store-business-hours">
            <dt>{{$t('StoreInfo.Grand')}}</dt>
            <dd>{{getSelectStore.outputs.grandTime}}</dd>
          </dl>
          {{text.Note}}
          <div class="store-map">
            <iframe :src="mapUrl" width="293" height="92" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
          </div>
        </div>
      </div>

      <p class="arrival-btn"><a href="#" class="btn-base btn-main" @click.prevent="storeArrival">{{$t('Order.ToStore')}}</a></p>

      <div class="mod-has-label">
        <span class="label">{{$t('Cart.OrderDetail')}}</span>
        <div class="mod-normal-box">
          <div class="order-detail-wrap">
            <!-- *** 商品 *** -->
            <div class="order-detail-item" v-for="(order, index) in getOrderDetail.items" :key="index">
              <h3 class="item-coupon-use" v-if="order.isUseCoupon">{{text.UseCoupon}}</h3>
              <h3 class="item-name"><span v-html="order.name"></span></h3>
              <div class="quantity">{{text.Quantity}}{{order.quantity}}</div>
              <p class="order-price"><strong>¥{{displayThousandsSeparator(order.price)}}</strong><small>{{order.taxType}}</small></p>
            </div>
            <!-- *** 商品 *** -->
            <!-- *** 会計割引クーポン *** -->
            <div class="order-detail-item" v-if="getOrderDetail.accountingCoupon.isUse">
              <h3 class="item-coupon-use">{{text.UseCoupon}}</h3>
              <h3 class="item-name"><span v-html="getOrderDetail.accountingCoupon.title"></span></h3>
              <p class="order-price"><strong>¥{{displayThousandsSeparator(getOrderDetail.accountingCoupon.discountPrice)}}</strong><small>{{getOrderDetail.accountingCoupon.taxType}}</small></p>
            </div>
            <!-- *** 会計割引クーポン *** -->

            <p class="total-price"><small>{{$t('General.Total')}}</small><strong>¥{{displayThousandsSeparator(getOrderDetail.totalPrice)}}</strong><small>{{getOrderDetail.taxType}}</small></p>
          </div>
        </div>
      </div>
      <p class="mod-form-btn"><a href="#" class="btn-base btn-negative btn-quit" @click.prevent="cancel">{{$t('Order.Cancel')}}</a></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '../mixins/CommonMixin'
export default {
  name: 'FKMOOrderFixing',
  data () {
    return {
      text: {
        CouponExcluded: null,
        NotApplying: null,
        Note: null,
        UseCoupon: null,
        Quantity: null
      },
      model: {
        lastOrderTime: null,
        orderEndTime: null,
        orderDetail: []
      },
      storeData: {
        name: null,
        address: null,
        lastOrder: null,
        tel: null,
        lat: null,
        lng: null,
        imageUrl: null
      },
      mapUrl: null
    }
  },
  mixins: [ CommonMixin ],
  computed: {
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getOrderDetail () {
      return this.$store.getters.orderDetail
    },
    getServerTime () {
      return this.$store.getters.serverTime
    },
    getCart () {
      return this.$store.getters.cart
    },
    getIsAcceptingMenu () {
      return this.$store.getters.isAcceptingMenu
    }
  },
  methods: {
    // 「支払い画面へ進む」ボタン
    storeArrival: function (event) {
      if (this.getSelectStore.enable_table_order && this.getCart.receive_method === '2') {
        // テーブルオーダー対応店舗、かつ「お店で食べる」場合はテーブル番号入力画面に遷移する
        this.$router.push({ name: 'TableOrderSelect' })
      } else {
        // それ以外のケースは支払い方法選択に遷移する
        this.$router.push({ name: 'PaymentMethod' })
      }
    },
    // 注文を取りやめる
    cancel: function (event) {
      // カートを初期化する
      this.clearCart(false)
      // Modelを初期化
      this.orderList = []
      this.totalPrice = null

      this.$router.push({ name: this.getHomepage() })
    },
    // 表示用受取店舗情報を生成
    genReceiveStore: function () {
      this.storeData = {
        name: this.getSelectStore.store_name,
        address: this.getSelectStore.address,
        lastOrder: this.getSelectStore.lastorder_time,
        tel: this.getSelectStore.lastorder_time,
        lat: this.getSelectStore.latitude,
        lng: this.getSelectStore.longitude,
        imageUrl: this.getSelectStore.image_url
      }

      // GoogleMapのURLを生成する
      this.mapUrl = 'https://maps.google.co.jp/maps?output=embed&q=loc:' + this.storeData.lat + ',' + this.storeData.lng + '&z=15&t=m'
    },
    // 受付終了時間を取得する
    getReceptionEndTime: function () {
      if (this.getIsAcceptingMenu.morning) {
        // NOTE モーニング時間帯の受け取り終了時間、ラストオーダー時間は固定文言で出力する
        this.model.orderEndTime = '10:00'
        // ラストオーダー時間
        this.model.lastOrderTime = '9:50'
      } else if (this.getIsAcceptingMenu.grand) {
        this.model.orderEndTime = this.getSelectStore.lastorder_time
        // ラストオーダー時間
        this.model.lastOrderTime = this.getSelectStore.lastorder_time
      }
    },
    initView: function () {
      // マウント後に画面出力する文字列を設定する
      this.text.CouponExcluded = this.$i18n.t('Cart.CouponExcluded')
      this.text.NotApplying = this.$i18n.t('Cart.NotApplying')
      this.text.Note = this.$i18n.t('ShopSearch.Note')
      this.text.UseCoupon = this.$i18n.t('Cart.UseCoupon')
      this.text.Quantity = this.$i18n.t('General.Quantity')
    }
  },
  // onload
  beforeMount () {
    // サーバー時間
    this.serverTime = this.getServerTime

    // 表示用受取店舗情報を生成する
    this.genReceiveStore()

    // 受付終了時間を取得する
    this.getReceptionEndTime()

    // 注文明細を生成する
    this.genOrderDetail()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  mounted () {
    this.initView()
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
.map {
  width: 100%;
  height: 55px;
  background: #696;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderFixing.vue